import type { IssueTypeField } from '../getIssueTypeFields';

export interface JiraFieldMapper {
  id: JiraFieldMappersKeys; // unique id identifying this mapper
  isEnum: boolean;
  canMapThisField: (jiraSchema: IssueTypeField[], fieldKey: string) => boolean;
  formatFieldValue: (
    jiraSchema: IssueTypeField[],
    fieldKey: string,
    sourceValue: unknown
  ) => unknown; // This will return formatted value or can potentially throw an exception if formatting is not possible
}

export enum JiraFieldMappersKeys {
  ShortText = 'jira-short-text-mapper',
  Labels = 'jira-labels-mapper',
  Number = 'jira-number-mapper',
  Url = 'jira-url-mapper',
  Date = 'jira-date-mapper',
  SingleOption = 'jira-single-option-mapper',
  MultiOptions = 'jira-multi-options-mapper'
}

export interface TemplateMappingSchemaV1 {
  [jiraFieldKey: string]: string;
}

export enum IssueFieldSource {
  Axe = 'AxeIssue',
  FixedValue = 'fixed_value'
}

export interface TemplateMappingSchemaV2 {
  // new field to indicate version. We should also check that the next field also exists and is equal to true. We will use 2 fields to avoid a situation where an unversioned variant of the schema will look like a versioned one.
  dmversion: number;
  dmversioned: boolean;
  mapping: {
    [jiraFieldKey: string]: {
      sourceType: IssueFieldSource; // enumerable list of where to source this value
      source: string; // which field should we source the value
      mapperId: JiraFieldMappersKeys; // which mapper we should use to format the value
    };
  };
  fields: IssueTypeField[];
}
